import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import SubCategoryServices from '../../services/SubCategoryServices';
function AddSubCategory() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    title: '',
    category: '',
    image: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await SubCategoryServices.getCategoryActive();
        if (res.status) {
          setCategories(res.data);
        } else {
          alert('Failed to fetch categories');
        }
      } catch (error) {
        console.error('Error fetching categories', error);
        alert('Failed to fetch categories');
      }
    };
    fetchCategories();
  }, []);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
  //   // Handle form submission
  const handleSubmit = async (event) => {
    // console.warn(formValues);
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }

      await SubCategoryServices.createSubCategory(formData);
      alert('SubCategory created successfully');
      navigate('/subcategory');

    } catch (error) {
      console.error('Failed to create SubCategory', error);
      alert('Failed to create SubCategory');
    }
  };

  return (
    <>
      <div className="right_col" role="main">

        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Sub Category Add
            </h5>
            <nav>
              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Sub Category Add
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <div className="pe-1 mb-xl-0">
              <Link className="list-banner-btn" to="/subcategory"> SubCategory List</Link>
            </div>
          </div>
        </div>




        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="input-field">
                  <label>SubCategory<span className="red">*</span></label>
                  <input type="text" name="title" value={formValues.title}
                    onChange={handleInputChange} defaultValue="Product scanning" className="form-control"  placeholder='New Category Title' />
                </div>

                <div className='row'>
                  <div className="col-lg-12 col-md-12">
                    <div className="input-field">
                      <label>Category*</label>
                      <select
                        name="category"
                        className="form-control"
                        value={formValues.category}
                        onChange={handleInputChange}
                      >
                        <option value="">Select a category</option>
                        {categories.map((category) => (
                          <option key={category._id} value={category._id}>
                            {category.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="input-field">
                  <label>Upload<span className="red">*</span></label>
                  <input type="file" name="image" className="form-control" onChange={handleFileChange}  />
                  <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                  <div className="file-preview text-center">
                    <img id="uploadFile" src={previewImage} alt="your image" />
                  </div>
                </div>
                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddSubCategory